<template>

    <div class="press-page message-page">
        <Header></Header>
        <section class="press-section message-section">
            <div class="container" v-if="loggedIn">
                <div class="row row-1 mobile-m h-mobile">
                    <div class="col-md-4">
                        <h2>Messages <a href="javascript:void(0)" data-toggle="modal" data-target="#artistListModal"><img src="@/assets/img/add.svg"/></a></h2>
                    </div>
                </div>
                <div class="row row-2">
                    <div class="col-md-4 mobile-m h-mobile">
                        <input type="Search" class="search-message-user" placeholder="Search"/>
                        <ul class="message-user-list">
                            <li v-for="list in messageList" :key="list._id" :data-id="list._id">
                                <router-link @click.native="activeFuntion" :to="`/artists/` + list.senderId._id + `/message`" v-if="senderId == list.receiverId._id" :class="{'unread-message' : (!list.read && (list.senderId._id !== receiverId))}">
                                    <div class="profile-user-img background-fit" :style="{ backgroundImage: `url(${imageUrl + list.receiverId.profiles[0].images[0].profileImageFile})` }"></div>
                                    <div class="message-user-detail" :id="list.receiverId._id">
                                        <h3 v-if="senderId != list.receiverId._id"><span>{{list.receiverId.name}}</span> <span>{{list.created | formatDateTime}}</span></h3>
                                        <h3 v-if="senderId == list.receiverId._id"><span>{{list.senderId.name}}</span> <span>{{list.created | formatDateTime}}</span></h3>
                                        <p>{{list.message}}</p>
                                    </div>
                                </router-link>
                                <router-link @click.native="activeFuntion" :to="`/artists/` + list.receiverId._id + `/message`" v-if="senderId != list.receiverId._id">
                                    <div class="profile-user-img background-fit" :style="{ backgroundImage: `url(${imageUrl + list.receiverId.profiles[0].images[0].profileImageFile})` }"></div>
                                    <div class="message-user-detail" :id="list.receiverId._id">
                                        <h3 v-if="senderId != list.receiverId._id"><span>{{list.receiverId.name}}</span> <span>{{list.created | formatDateTime}}</span></h3>
                                        <h3 v-if="senderId == list.receiverId._id"><span>{{list.senderId.name}}</span> <span>{{list.created | formatDateTime}}</span></h3>
                                        <p>{{list.message}}</p>
                                    </div>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                    <div class="col-md-8 message-chat mobile-m">
                        <a href="javascript:void(0)" class="show-all"><img src="@/assets/img/next.svg"/> ALL MESSAGES</a>
                        <h4>{{artist.name}}</h4>
                        <ul class="message-list">
                            <li v-if="lists.length" v-for="(list) in lists" v-bind:key="list.id" :class="{'message-user' : senderId == list.receiverId._id, 'message-reveiver' : senderId != list.receiverId._id}">
                                <div class="message-p background-fit" :style="{ backgroundImage: `url(${imageUrl + list.receiverId.profiles[0].images[0].profileImageFile})` }"></div>
                                <div class="message-b">
                                    {{list.message}}
                                </div>
                                <span class="message-time">{{list.created | formatDateTime}}</span>
                            </li>
                            <!--<li v-if="!lists.length" style="padding-left: 10px;">-->
                                <!--No Message-->
                            <!--</li>-->
                        </ul>
                        <div class="send-message">
                            <form class="form" v-on:submit.prevent="submitForm" enctype="multipart/form-data">
                                <input type="text" class="message-field" placeholder="Type here..." />
                                <button type="submit">SUBMIT</button>
                                <!--<a href="javascript:void(0)" class="message-send-button">Send</a>-->
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <Loader v-if="loading" />
        </section>
        <!-- Modal -->
        <div class="modal fade" id="artistListModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Artists List</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <input type="Search" class="search-user" placeholder="Search"/>
                        <ul class="list-unstyled">
                            <li class="art-p" v-for="(list) in artistLists" v-if="artistLists.length && list.profiles[0].profession" v-bind:key="list.id">
                                <router-link :to="`/artists/`+list._id+`/message`" data-dismiss="modal" aria-label="Close">
                                    <div class="background-fit" :style="{ backgroundImage: `url(${imageUrl + list.profiles[0].images[0].profileImageFile})` }"></div>
                                    <h3>{{list.name}}</h3>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from './Header'
    import Footer from './Footer'
    import Loader from './include/Loader'
    import axios from 'axios'
    import router from '../router'
    import $ from "jquery"
    import artistBackground from '@/assets/img/profile_bg.jpg'
    import Vue from 'vue'
    import VueToast from 'vue-toast-notification'
    import 'vue-toast-notification/dist/index.css'
    import moment from 'moment'
    Vue.use(VueToast)

    export default {
        name: 'Message',
        components: {
            'Header': Header,
            'Footer': Footer,
            'Loader': Loader
        },
        data() {
            return {
                msg: 'Welcome to Your Vue.js App',
                imageUrl: process.env.imageUrl,
                loading: false,
                artistBg: artistBackground,
                lists: '',
                messageList: '',
                artistLists: '',
                artist: '',
                senderId: '',
                sendername: '',
                senderemail: '',
                loggedIn: false,
                receiverId: router.history.current.params.id
            }
        },
        mounted () {
            var userdata = localStorage.getItem('cbs_usertoken')
            var $this = this
            if(userdata){
                this.loggedIn = true
                this.getAllArtist()
                userdata = JSON.parse(userdata)
                this.senderId = userdata.user.id
                this.sendername = userdata.user.name
                this.senderemail = userdata.user.email
                axios
                    .get('/getMessageArtistsList', {
                        params: {
                            senderId: this.senderId
                        }
                    })
                    .then(response => {
                        this.loading = false
                        let data = {}
                        let finalData = []
                        $.each(response.data, function (key, value) {
                            if(value.senderId.email !== $this.senderemail){
                                data[value.senderId._id] = value
                            } else if(value.receiverId.email !== $this.senderemail){
                                data[value.receiverId._id] = value
                            }
                        })

                        $.each(data, function (key, value) {
                            finalData.push(value)
                        })

                        this.messageList = finalData
                    })
                    .catch(error => console.log(error))

                axios
                    .get('/getMessages', {
                        params: {
                            senderId: this.senderId,
                            receiverId: this.receiverId
                        }
                    })
                    .then(response => {
                        this.loading = false
                        this.lists = response.data
                        if(this.lists.length){
                            axios.post('/readMessage', {
                                messageId: this.lists[this.lists.length - 1]._id
                            }).then(function (response) {
                                // handle success
                            })
                        }
                        setTimeout(function () {
                            $(".message-list").scrollTop($(".message-list")[0].scrollHeight)
                        }, 10)
                    })
                    .catch(error => console.log(error))

                axios
                    .get('/getartistdetail', {
                        params: {
                            artistId: this.receiverId
                        }
                    })
                    .then(response => {
                        this.artist = response.data

                    })
                    .catch(error => console.log(error))

                $('.search-message-user').on("keyup", function() {
                    var value = $(this).val().toLowerCase();
                    $('.message-user-list h3 span:first-child').filter(function() {
                        $(this).closest('li').toggle($(this).text().toLowerCase().indexOf(value) > -1)
                    })
                })
                $('.search-user').on("keyup", function() {
                    var value = $(this).val().toLowerCase();
                    $('#artistListModal h3').filter(function() {
                        $(this).closest('li').toggle($(this).text().toLowerCase().indexOf(value) > -1)
                    })
                })

                $('.show-all').click(function () {
                    $('.mobile-m').toggleClass('h-mobile')
                })

            } else {
                router.push({ name: 'Login' })
            }
        },
        methods: {
            activeFuntion: function(event){
              if($(event.target).hasClass('router-link-exact-active') || $(event.target).parents().hasClass('router-link-exact-active')){
                  $('.mobile-m').toggleClass('h-mobile')
              }
            },
            getAllArtist: function(){
                axios
                    .get('/artists', {
                        role: 'artist'
                    })
                    .then(response => {
                        this.artistLists = response.data
                    })
                    .catch(error => {})
            },
            submitForm: function(event){
                let $this = this
                var message = $('.message-field').val()
                if(message){
                    axios.post('/addMessage', {
                        senderId: this.senderId,
                        receiverId: this.receiverId,
                        message: message
                    }).then(function (response) {
                        // handle success
                        let currentTime = new Date()
                        var html = '<li class="message-reveiver"><div class="message-b">'+message+'</div><span class="message-time">'+moment(String(new Date())).format('LT')+'</span></li>'
                        $('.message-list').append(html)
                        $('.message-field').val('')
                        $('.message-list').stop().animate({
                            scrollTop: $('.message-list')[0].scrollHeight
                        }, 800)
                    })
                } else {
                    Vue.$toast.open(
                        {
                            message: 'Fill field',
                            type: 'error',
                            position: 'top-right'
                            // all other options
                        }
                    )
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Message.vue